/**
 * Runs a browser-language detection ONCE at app boot, before i18next initialises,
 * so localStorage.hx_lang is populated for both the i18next-consuming pages
 * (HannoNexus) and the local-dictionary consumers (MIONGA).
 *
 * Import this file for its SIDE EFFECT — the detection runs at module evaluation:
 *     import "@/i18n/detect";
 *
 * Detection rules (map browser locale → supported language):
 *   pt-*  → pt     (Portugal, Brazil, Angola, Cabo Verde, Mozambique …)
 *   de-*  → de     (Germany, Austria, Switzerland-DE, Luxembourg-DE)
 *   fr-*  → fr     (France, Belgium-FR, Switzerland-FR, Canada-FR)
 *   en-*  → en     (fallback for all English variants)
 *   other → en     (safe institutional default)
 *
 * The user's explicit LanguageSwitcher choice (also stored under hx_lang)
 * takes precedence — this detection only runs when hx_lang is empty.
 */
const SUPPORTED = ["pt", "de", "fr", "en"];

if (typeof window !== "undefined") {
  try {
    const existing = window.localStorage.getItem("hx_lang");
    if (!existing || !SUPPORTED.includes(existing)) {
      const candidates = (navigator.languages && navigator.languages.length
        ? navigator.languages
        : [navigator.language || "en"]);

      let picked = null;
      for (const raw of candidates) {
        if (!raw) continue;
        const base = String(raw).toLowerCase().split("-")[0];
        if (SUPPORTED.includes(base)) { picked = base; break; }
      }
      window.localStorage.setItem("hx_lang", picked || "en");
    }
  } catch (_) {
    // localStorage disabled or unavailable — safe to no-op
  }
}

export {}; // marks this file as an ES module
